import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import {
  dismissAppLaunchSplash,
  holdBrowserTripLaunchSplash,
  isStandaloneDisplay,
  isTripLaunchPath,
  removeAppLaunchSplashImmediate,
} from '@/lib/pwa/app-launch';

const STANDALONE_SPLASH_TIMEOUT_MS = 12_000;

/**
 * Normal browser tabs drop the splash everywhere except `/trips*`, where it
 * stays visible (pointer-events: none) for a steady label until release.
 * Installed apps keep it until a release hook or this timeout fires.
 */
export function AppLaunchSplashSafety() {
  const location = useLocation();

  useEffect(() => {
    if (isStandaloneDisplay()) return;
    if (isTripLaunchPath(location.pathname)) {
      holdBrowserTripLaunchSplash();
      return;
    }
    removeAppLaunchSplashImmediate();
  }, [location.pathname, location.search]);

  useEffect(() => {
    if (!isStandaloneDisplay()) return;
    const timeout = window.setTimeout(() => dismissAppLaunchSplash(), STANDALONE_SPLASH_TIMEOUT_MS);
    return () => window.clearTimeout(timeout);
  }, []);

  return null;
}
